import type { PartialSemanticPaletteColors, WhitelabelThemeRegistry, WhitelabelVariantDefinition } from '../types';
import { beedigitalWhitelabelThemeEntry } from './bee-ddt';
import { engacontWhitelabelThemeEntry } from './engacont';
import { fcrWhitelabelThemeEntry } from './fcr-be';
import { leadzaiWhitelabelThemeEntry } from './leadzai';
import { linkmercWhitelabelThemeEntry } from './linkmerc';
import { loclsrchWhitelabelThemeEntry } from './loclsrch';
import { medialuoWhitelabelThemeEntry } from './medialuo';
import { mediamagWhitelabelThemeEntry } from './mediamag';
import { pagAmrlWhitelabelThemeEntry } from './pag-amrl';
import { pblcrEstWhitelabelThemeEntry } from './pblcrEst';
import { youviaWhitelabelThemeEntry } from './youvia';

export const DEFAULT_WHITELABEL_ID = 'leadzai';
export const DEFAULT_THEME_VARIANT = 'default';
export const DEFAULT_FONT_FAMILY = 'DM Sans';

export const WHITELABEL_THEME_REGISTRY: WhitelabelThemeRegistry = {
  'bee-ddt': beedigitalWhitelabelThemeEntry,
  engacont: engacontWhitelabelThemeEntry,
  'fcr-be': fcrWhitelabelThemeEntry,
  leadzai: leadzaiWhitelabelThemeEntry,
  linkmerc: linkmercWhitelabelThemeEntry,
  loclsrch: loclsrchWhitelabelThemeEntry,
  medialuo: medialuoWhitelabelThemeEntry,
  mediamag: mediamagWhitelabelThemeEntry,
  'pag-amrl': pagAmrlWhitelabelThemeEntry,
  pblcrEst: pblcrEstWhitelabelThemeEntry,
  youvia: youviaWhitelabelThemeEntry,
};

export function getWhitelabelThemeEntry(whitelabelId: string) {
  return WHITELABEL_THEME_REGISTRY[whitelabelId] ?? WHITELABEL_THEME_REGISTRY[DEFAULT_WHITELABEL_ID];
}

export function resolveEffectiveWhitelabelId(whitelabelId: string | undefined): string {
  return whitelabelId && whitelabelId in WHITELABEL_THEME_REGISTRY ? whitelabelId : DEFAULT_WHITELABEL_ID;
}

export function listWhitelabelThemeVariants(whitelabelId: string): string[] {
  const entry = getWhitelabelThemeEntry(whitelabelId);
  return Object.keys(entry.themes);
}

function resolveWhitelabelVariantLayers(
  whitelabelId: string | undefined,
  variant: string | undefined,
): WhitelabelVariantDefinition[] {
  const id = whitelabelId && whitelabelId in WHITELABEL_THEME_REGISTRY ? whitelabelId : DEFAULT_WHITELABEL_ID;
  const entry = getWhitelabelThemeEntry(id);
  const variantKey = variant && variant in entry.themes ? variant : DEFAULT_THEME_VARIANT;

  const layers: WhitelabelVariantDefinition[] = [entry.themes.default];

  if (variantKey !== DEFAULT_THEME_VARIANT && entry.themes[variantKey]) {
    layers.push(entry.themes[variantKey]);
  }

  return layers;
}

export function resolveWhitelabelSemanticPartials(
  whitelabelId: string | undefined,
  variant: string | undefined,
): PartialSemanticPaletteColors[] {
  return resolveWhitelabelVariantLayers(whitelabelId, variant).map((layer) => layer.palette);
}

export function resolveWhitelabelFontFamily(whitelabelId: string | undefined, variant: string | undefined): string {
  const layers = resolveWhitelabelVariantLayers(whitelabelId, variant);

  for (let i = layers.length - 1; i >= 0; i--) {
    const fontFamily = layers[i].typography?.fontFamily;
    if (fontFamily) {
      return fontFamily;
    }
  }

  return DEFAULT_FONT_FAMILY;
}
